export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";